import { array, struct } from 'io-ts/Decoder';

import { Id as ClientId } from '../../../../client/Id';
import { Id as TransactionId } from '../../../../transaction/Id';
import { Id as UserId } from '../../../../user/Id';

export const Request = struct({
	clientId: ClientId,
	transactionIds: array(TransactionId),
	userId: UserId,
});
